import HttpClient from './HttpClient';

const CobranzaService = {
  getVisitas: (id) => {
    const path = 'collection/visit/' + id;
    return HttpClient.get(path, {}, true);
  },
  saveVisit: (params) => {
    const path = 'collection/visit';
    return HttpClient.post(path, params, true);
  }
};

export default CobranzaService;
